import {requestGet, requestPost} from '@/utils/request';

const api = {
    LIST: '/op/conversation_list',
	MESSAGE_DETAIL: '/op/conversation_message_detail',
}

export async function conversationList(queryParams) {
    return requestGet(api.LIST, queryParams);
}

export async function conversationMessageDetail(queryParams) {
    return requestPost(api.MESSAGE_DETAIL, queryParams);
}
